module.exports = __webpack_public_path__ + "static/media/maggot-brain.6efe9b71.jpg";